<template>
  <div class="template-section">
    <h2 class="mb-4 text-base xxl:text-xl capitalize hidden xl:block">
      {{ computedTitle }}
    </h2>
    <TemplateSliderSkeleton v-if="isLoading" />
    <div v-else class="grid-row">
      <TemplateCard
        v-for="itemCategory in categorySelected.PresentationsCategories"
        v-aha-emit-action="{ template_id: itemCategory.id }"
        name="template-card"
        :key="itemCategory.id"
        :presentation="itemCategory.Presentation"
        :copyType="copyType"
        :customHandler="handleClickTemplate ? handleSelectTemplate : null"
      />
    </div>
  </div>
</template>
<script>
import TemplateCard from './TemplateCard.vue'
import TemplateSliderSkeleton from './TemplateSliderSkeleton.vue'

export default {
  components: {
    TemplateCard,
    TemplateSliderSkeleton,
  },
  props: {
    categorySelected: {
      type: Object,
      default: () => {
        return {
          PresentationsCategories: [],
        }
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    copyType: {
      type: String,
      default: '',
    },
    handleClickTemplate: {
      type: Function,
      required: false,
      default: null,
    },
  },
  computed: {
    computedTitle() {
      const key = this.title || (this.categorySelected && this.categorySelected.name)

      return key ? this.$i18nPresenter.t(key) : ''
    },
  },
  methods: {
    handleSelectTemplate(template) {
      if (this.handleClickTemplate) {
        this.handleClickTemplate(template)
      }
    },
  },
}
</script>
<style scoped lang='scss'>
@import "@/assets/scss/variable.scss";

.grid-row {
  @apply grid gap-x-4 gap-y-5 md:gap-8 xl:gap-4 3xl:gap-6;
  @apply grid-cols-1 sm:grid-cols-2;

  @media (min-width: 1400px) {
    grid-template-columns: repeat(auto-fit, minmax($template-card-base-width, 1fr));
  }
}
</style>
